import styled from "styled-components";
import { LighterText } from "./HXDesktopPage.styles";
import { HXIconMenuButton } from "./HXIconMenuButton";
import { colors } from "healthex-common/colors";
import { FlexRowDiv } from "./common.styles";
import { HXPageHeader } from "./HXDesktopPage";
export const ProtocolNumber = styled(LighterText) `
    height: 40;
    line-height: 40px;
`;
export const ManageStudyMenuButton = styled(HXIconMenuButton) `
    border-radius: 4px;
    border: 1px solid ${colors.black_12};
`;
export const TitleRowButton = styled(FlexRowDiv) `
    gap: 8px;
    align-items: center;
    align-self: flex-start;
`;
export const HXDesktopStudyHeaderParent = styled(HXPageHeader) `
    background-color: ${colors.white_main};
    // "cheat" the container bigger so it covers the margins too
    padding: 0px 80px;
    margin: 0 -80px;
    padding-top: 16px;
    margin-top: -16px;
`;
